/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Header Sort Icon component.
 */
export const HeaderSortIcon = ({
  size = IconSize.largeMedium,
  color = dlsColor('grey3')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width={iconSize} height={iconSize} rx='8' fill={dlsColor('grey6')} />
      <g clipPath='url(#clip0_21088_94226)'>
        <path d='M13.6175 12.5348L11.0775 10.1948L8.64246 12.5348' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M11.1274 17.8049V10.9849' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M14.3824 15.4648L16.9224 17.8048L19.3574 15.4648' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M16.8674 10.1948V17.0148' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_21088_94226'>
          <rect width='16' height='16' fill='white' transform='translate(8 8)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HeaderSortIcon;
